module.exports = __webpack_public_path__ + "static/img/Dustin_Martin_desktop.85aecd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dustin_Martin_desktop.jpg
// module id = G0u0
// module chunks = 0